/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */

 // import utils
 require('./utils/jquery.autocomplete.js');

// Import custom modules
import App from './modules/app.js';
import Carousel from './modules/carousel.js';
import Header from './modules/header.js';
import Autocomplete from './partials/autocomplete.js'
import Menu from './partials/menu.js';
import Breadcrumb from './partials/breadcrumb.js';
import Pagination from './partials/pagination.js';
import SearchJour from './partials/search-jour.js';
import Intranet from './partials/intranet.js';
import Filter from './partials/filter.js';
import CalendarWidget from './utils/CalendarWidget.js';

const app = new App();
const carousel = new Carousel();
const header = new Header();
const autocomplete = new Autocomplete();
const menu = new Menu();
const breadcrumb = new Breadcrumb();
const pagination = new Pagination();
const searchjour = new SearchJour();
const intranet = new Intranet();
const filter = new Filter();
const calendarwidget = new CalendarWidget();
